import { Box, CircularProgress } from "@mui/material";
interface LoadingMoreStatusProps {
  currentCount: number;
}

export const LoadingMoreStatus = ({ currentCount }: LoadingMoreStatusProps) => {
  return (
    <Box style={{ margin: "10px", display: "flex" }}>
      <CircularProgress size={20} style={{ marginRight: "10px" }} />
      {currentCount} {"loaded... more to go!"}
    </Box>
  );
};
